/**
 * Телефон — только грубый палец и узкая рамка вместе.
 *
 * Узкое окно мышью на столе остаётся столом. jsdom без matchMedia — стол.
 * Принудительно: html[data-forq-phone="1"] (тесты). Никогда не ставим флаг
 * сами на десктопе.
 */

export const PHONE_MAX = 720;

export function isPhone(win: Window = window): boolean {
  if (typeof document !== 'undefined' && document.documentElement.dataset.forqPhone === '1') {
    return true;
  }
  if (typeof document !== 'undefined' && document.documentElement.dataset.forqPhone === '0') {
    return false;
  }
  if (typeof win.matchMedia !== 'function') return false;
  try {
    const coarse = win.matchMedia('(pointer: coarse)').matches;
    const narrow = win.matchMedia(`(max-width: ${PHONE_MAX}px)`).matches;
    return coarse && narrow;
  } catch {
    return false;
  }
}

export function applyPhoneFlag(win: Window = window): void {
  const root = win.document.documentElement;
  if (root.dataset.forqPhone === '0') return;
  if (root.dataset.forqPhone === '1') return;
  if (isPhone(win)) root.dataset.forqPhone = '1';
  else delete root.dataset.forqPhone;
}

export function webOnly(): boolean {
  try {
    return sessionStorage.getItem('forq.phone.webOnly') === '1';
  } catch {
    return false;
  }
}

export function setWebOnly(on: boolean): void {
  try {
    if (on) sessionStorage.setItem('forq.phone.webOnly', '1');
    else sessionStorage.removeItem('forq.phone.webOnly');
  } catch {
    /* private mode */
  }
}
